import * as R from 'ramda';

export const mergeNewComponent = (newFieldDefault, fields, id) => {
    const originalField = R.find(R.propEq('id', id), fields);
    let omitFields = ['component', 'value'];
    if (R.contains(originalField.component, ['date', 'time'])) {
        omitFields = R.append('format', omitFields);
    }
    const sharedValues = R.pipe(
        R.pick(R.keys(newFieldDefault)),
        R.omit(omitFields)
    )(originalField);
    return R.merge(newFieldDefault, sharedValues);
};

export const replaceUpdatedField = (fields, updatedField) => {
    const fieldIndex = R.findIndex(R.propEq('id', updatedField.id), fields);
    return R.update(fieldIndex, updatedField, fields);
};

export const updateFields = (fields, payload) => {
    return R.pipe(
        findFieldToUpdate,
        adjustFieldValue
    )(fields, payload);
};

export const addNewField = (fields, selectedField, newField) => {
    const selectedIndex = R.findIndex(R.propEq('id', selectedField))(fields);
    return R.insert(selectedIndex + 1, newField, fields);
};

export const findNextField = (selectedFieldIndex, fields) => {
    const isNext = R.gte(selectedFieldIndex, fields.length - 1);
    return isNext ? fields[0].id : fields[selectedFieldIndex + 1].id;
};

function findFieldToUpdate (fields, { id, property, value }) {
    const i = R.findIndex(R.propEq('id', id), fields);
    return { i, fields, property, value }
}

function adjustFieldValue ({ i, fields, property, value }) {
    const f = property === 'validations' ? adjustFormValidation : adjustFormField;
    return f(i, value, fields, property);
}

function adjustFormField (i, value, fields, property) {
    return R.adjust(i, R.assoc(property, value), fields);
}

function adjustFormValidation (i, value, fields) {
    const associateData = R.assocPath(['validations', value.name, value.property], value.value);
    return R.adjust(i, associateData, fields);
}
